import { render, staticRenderFns } from "./DiscountManagementByProperty.vue?vue&type=template&id=1d6e49de&scoped=true&"
import script from "./DiscountManagementByProperty.vue?vue&type=script&lang=js&"
export * from "./DiscountManagementByProperty.vue?vue&type=script&lang=js&"
import style0 from "./DiscountManagementByProperty.vue?vue&type=style&index=0&id=1d6e49de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e49de",
  null
  
)

export default component.exports